export const MINISTATEMENT_REQUEST = "MINISTATEMENT_REQUEST"
export const MINISTATEMENT_SUCCESS = "MINISTATEMENT_SUCESS"
export const MINISTATEMENT_FAIL = "MINISTATEMENT_FAIL"
export const MINISTATEMENT_RESET = "MINISTATEMENT_RESET"

export const UPDATE_STATEMENT_STATUS_REQUEST = "UPDATE_STATEMENT_STATUS_REQUEST"
export const UPDATE_STATEMENT_STATUS_SUCCESS = "UPDATE_STATEMENT_STATUS_SUCCESS"
export const UPDATE_STATEMENT_STATUS_FAIL = "UPDATE_STATEMENT_STATUS_FAIL"
export const UPDATE_STATEMENT_STATUS_RESET = "UPDATE_STATEMENT_STATUS_RESET"
